import { gql } from "@apollo/client";

export default gql`
  query getProfileOverviewQuery(
    $userId: Int!
    $nextOneononeAfterDate: DateTime!
    $lastOneononeBeforeDate: DateTime!
  ) {
    user(userId: $userId) {
      id
      name
      firstName
      email
      avatar
      timezone
      email
      lastSeenStr
      isInCurrentUserReportingTree
      teamsList {
        id
        title
      }
      managersList {
        id
        name
        avatar
      }
      directReports {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      currentRoles {
        id
        title
      }
      nextOneonones: meetings(
        isFormalOneonone: true
        draft: false
        startDatetime_Gte: $nextOneononeAfterDate
        first: 1
        orderBy: "start_datetime"
      ) {
        edges {
          node {
            id
            startDatetime
            endDatetime
            title
            meetingGroupId
          }
        }
      }
      lastOneonones: meetings(
        isFormalOneonone: true
        draft: false
        startDatetime_Lte: $lastOneononeBeforeDate
        first: 1
        orderBy: "-start_datetime"
      ) {
        edges {
          node {
            id
            startDatetime
            endDatetime
            title
            meetingGroupId
            transcript {
              id
              summary
            }
          }
        }
      }
      ownedGoals(goalState: open) {
        edges {
          node {
            id
            ... on GoalArtifactNode {
              isStale
              status
              state
            }
          }
        }
      }
    }
  }
`;
